import { type Control, useWatch } from 'react-hook-form';

import ShippingLabel from '@/components/steps/ShippingAddressStep/ShippingLabel';
import { ADDRESS_TYPE, type ShippingSchemaType } from '@/components/steps/ShippingAddressStep/shippingSchema';
import { useDisplayNames } from '@/hooks/useDisplayNames';
import { t } from '@/lib/utils';

type ShippingLabelPreviewProps = {
    control: Control<ShippingSchemaType>;
};

const ShippingLabelPreview = ({ control }: ShippingLabelPreviewProps) => {
    const addressType = useWatch({ control, name: 'addressType' }) ?? ADDRESS_TYPE.company;
    const companyName = useWatch({ control, name: 'companyName' });
    const recipient = useWatch({ control, name: 'addressee' });
    const address = useWatch({ control, name: 'address' });
    const address2 = useWatch({ control, name: 'address2' });
    const postCode = useWatch({ control, name: 'postCode' });
    const city = useWatch({ control, name: 'city' });
    const country = useWatch({ control, name: 'country' });
    const displayCountryName = useDisplayNames();
    const countryLabel = country ? displayCountryName?.(country) : undefined;

    const showCompanyName = addressType === ADDRESS_TYPE.company && Boolean(companyName);

    return (
        <div className='display-flex flex-column flex-1-1-0'>
            <span className='text-size-12 text-color-dark margin-bottom-15'>
                {t('onboarding.shippingAddress.shippingLabelPreview')}
            </span>
            <ShippingLabel
                bordered
                companyName={showCompanyName ? companyName : undefined}
                recipient={recipient}
                addressLine1={address}
                addressLine2={address2}
                postCode={postCode}
                city={city}
                countryLabel={countryLabel}
            />
        </div>
    );
};

export default ShippingLabelPreview;
